export enum SurveyType {
    Seismic2D = 0,
    Seismic3D = 1,
    Seismic2DPreStack = 3
}